import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageSwitcher from './PageSwitcher';
import './CreatePostModal.css';

const DashboardHeader = ({ isUser, myPosts, onToggleMyPosts }) => {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleSelectPostType = (type) => {
    setShowModal(false);
    if (type === 'car') {
      navigate('/car-listing');
    } else {
      navigate('/driver-listing');
    }
  };

  return (
    <div className="dashboard-header">
      <PageSwitcher />
      {isUser && (
        <div className="header-actions">
          <button
            className={`my-posts-btn ${myPosts ? 'active' : ''}`}
            onClick={onToggleMyPosts}
          >
            My Posts
          </button>
          <button className="post-btn" onClick={() => setShowModal(true)}>
            + Create Post
          </button>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="create-post-modal" onClick={(e) => e.stopPropagation()}>
            <h2>What are you posting?</h2>
            <p>Select the type of post you want to create</p>

            <div className="post-type-options">
              <button
                className="post-type-card"
                onClick={() => handleSelectPostType('car')}
              >
                <div className="post-type-icon car-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/>
                  </svg>
                </div>
                <div className="post-type-info">
                  <h3>Car Listing</h3>
                  <p>I have a car and need a driver</p>
                </div>
              </button>

              <button
                className="post-type-card"
                onClick={() => handleSelectPostType('driver')}
              >
                <div className="post-type-icon driver-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                </div>
                <div className="post-type-info">
                  <h3>Driver Listing</h3>
                  <p>I'm a driver looking for work</p>
                </div>
              </button>
            </div>

            <button className="modal-close-btn" onClick={() => setShowModal(false)}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardHeader;
